import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import '@mdi/font/css/materialdesignicons.css';

// creating a Vuetify instance
const vuetify = createVuetify({
    defaults: {  //
        VContainer: {
            fluid: true,
        }
    },
    components,
    directives
})

// creating Vue app
const app = createApp(App)
app.use(router)
app.use(vuetify)

// Google Analytics (tracks router page views)
router.afterEach((to) => {
    if (typeof gtag === "function") {
        window.gtag('config', 'G-RG746EFQ1K', {
            page_path: to.fullPath,
        });
    }
});

app.mount('#app')
